module.exports = __webpack_public_path__ + "static/media/Trace-Bot-Soccer.79b651b8.svg";